import colors from "../../../utils/colors";

export const PICKER_PRIMARY = colors.primary[300];
export const PICKER_PRIMARY_HOVER = colors.primary[400];
export const PICKER_PRIMARY_SOFT = colors.primary[100];

export const LAYERD_SINGLE_DATETIME_PICKER_CLASS = "layerd-single-datetime-picker";

/** Content area height — calendar header + weekday row + 220px grid (matches date step). */
export const PICKER_BODY_MIN_HEIGHT = 315;
